const messages: Record<string, string> = {
  'site.title':           'Metha · docs',
  'site.tagline':         'Financiación on-chain para la investigación biomédica.',
  'nav.search':           'Buscar en la documentación…',
  'search.empty':         'Sin resultados.',
  'search.unavailable':   'Índice de búsqueda no compilado. Ejecuta `npm run build` y `npm run preview`.',
  'nav.dapp':             'Abrir la dapp',
  'toc.onThisPage':       'En esta página',
  'nav.home':             'Inicio',
  'sidebar.toggle':       'Mostrar/ocultar navegación',
  'theme.toggle':         'Cambiar tema',
  'lang.switch':          'Idioma',
  'home.cta.lab':         'Soy un laboratorio',
  'home.cta.auditor':     'Soy un auditor',
  'home.cta.learn':       'Quiero entenderlo',
  'home.section.start':   'Empezar',
  'home.section.status':  'Estado en vivo',
  'home.section.recent':  'Añadido recientemente',
  'page.lastUpdated':     'Última actualización',
  'page.editOnGithub':    'Editar esta página en GitHub',
  'page.onThisPage':      'En esta página',
  '404.title':            'Página no encontrada',
  '404.body':             'La página solicitada no existe.',
  '404.back':             'Volver al inicio',

  // pie
  'community':            'Comunidad',
  'code':                 'Codigo y publicaciones',
  'onchain':              'En cadena (Sepolia)',
  'disclaimer':           'Software experimental, sin garantias. METH se disena como instrumento de liquidacion y gobernanza, no como valor mobiliario ni derecho de redencion sobre activos de Metha. Nada en este sitio constituye asesoramiento legal, fiscal, financiero o de inversion. Consulta el registro de riesgos para las exposiciones regulatorias y tecnicas conocidas.',

  // ── secciones del manifest ──
  'manifest.section.overview':     'Resumen',
  'manifest.section.how-it-works': 'Cómo funciona',
  'manifest.section.architecture': 'Arquitectura',
  'manifest.section.concepts':     'Conceptos básicos',
  'manifest.section.guides':       'Guías de usuario',
  'manifest.section.security':     'Seguridad',
  'manifest.section.risks':        'Riesgos',
  'manifest.section.future':       'Desarrollos futuros',
  'manifest.section.literature':   'Literatura',
  'manifest.section.glossary':     'Glosario',
  'manifest.section.faq':          'FAQ',
  'manifest.section.changelog':    'Changelog',

  // ── hojas del manifest ──
  'manifest.leaf.overview':                    'Qué es Metha',
  'manifest.leaf.why-dvbc':                    'Por qué DVBC',
  'manifest.leaf.status':                      'Estado y hoja de ruta',
  'manifest.leaf.how-it-works/value-loop':     'El bucle de valor',
  'manifest.leaf.how-it-works/auctions':       'Subastas periódicas',
  'manifest.leaf.how-it-works/requests':       'Solicitudes de financiación',
  'manifest.leaf.how-it-works/consensus':      'Consenso de auditores',
  'manifest.leaf.how-it-works/governance':     'Gobernanza',
  'manifest.leaf.architecture':                'Diagrama del sistema',
  'manifest.leaf.architecture/contracts':      'Seis contratos',
  'manifest.leaf.architecture/data-flow':      'Flujo de datos',
  'manifest.leaf.architecture/evolution':      'Registro de slots y evolución',
  'manifest.leaf.concepts/dvbc':               'DVBC',
  'manifest.leaf.concepts/three-conditions':   'Tres condiciones',
  'manifest.leaf.concepts/mechanisms-abc':     'Mecanismos A / B / C',
  'manifest.leaf.concepts/typed-deliverables': 'Entregables tipados',
  'manifest.leaf.concepts/barda-option':       'Opción-periodo BARDA',
  'manifest.leaf.concepts/dsmb-veto':          'Veto DSMB',
  'manifest.leaf.concepts/slashing':           'Niveles de slashing',
  'manifest.leaf.guides/lab':                  'Para laboratorios',
  'manifest.leaf.guides/auditor':              'Para firmas auditoras',
  'manifest.leaf.guides/holder':               'Para titulares de tokens',
  'manifest.leaf.guides/dsmb':                 'Para miembros DSMB',
  'manifest.leaf.guides/program-officer':      'Para Program Officers',
  'manifest.leaf.guides/developer':            'Para desarrolladores',
  'manifest.leaf.guides/developer/mdx-components': 'Referencia de componentes MDX',
  'manifest.leaf.security/slither':            'Resumen del informe Slither',
  'manifest.leaf.security/audits':             'Secuencia de auditorías',
  'manifest.leaf.security/reporting':          'Reportar una vulnerabilidad',
  'manifest.leaf.risks':                       'Registro de riesgos',
  'manifest.leaf.future/roadmap':              'Hoja de ruta',
  'manifest.leaf.future/research':             'Preguntas de investigación abiertas',
  'manifest.leaf.literature':                  'Papers y referencias',
  'manifest.leaf.glossary':                    'Glosario',
  'manifest.leaf.faq':                         'FAQ',
  'manifest.leaf.changelog':                   'Changelog',
};

export default messages;
